import { getArrayFromStorage } from '../utils';
import { AddToFavourite } from './addToFavourite';
import { Carousel } from './carousel';
import { GsapAnimations } from './gsapAnimations';
import { LazyLoadImage } from './lazyLoadImage';
export class Wishlist {
    el;
    wishlist;
    params;
    operatorIds;
    wishistItems;
    constructor(el) {
        this.el = el;
        this.wishistItems = el.querySelector('#wishlist-items');
        this.params = new URLSearchParams(window.location.search);
        this.operatorIds = this.params.get('operatorIds');
        this.wishlist = getArrayFromStorage('scrimWishlist');
        this.init();
    }
    init() {
        if (this.wishlist.length === 0 && !this.operatorIds) {
            const noWishlistItems = this.el.querySelector('#no-wishlist-items');
            noWishlistItems?.classList.remove('hidden');
        }
        else {
            const params = {
                nonce: window.mainSiteData.nonce,
                ids: this.operatorIds ? this.operatorIds : this.wishlist.join(',')
            };
            Wishlist.fetch(`${window.mainSiteData.root}scenic-rim/v2/wishlist?${new URLSearchParams(params)}`).then(html => {
                if (this.wishistItems) {
                    this.wishistItems.innerHTML = html;
                }
            }).then(() => {
                const addToWishlistButtons = document.querySelectorAll('[data-wishlist]');
                const carousels = document.querySelectorAll('.carousel');
                if (addToWishlistButtons.length > 0) {
                    Array.from(addToWishlistButtons, button => {
                        new AddToFavourite(button);
                    });
                }
                if (carousels.length > 0) {
                    Array.from(carousels, carousel => {
                        new Carousel(carousel);
                    });
                }
                new GsapAnimations();
                new LazyLoadImage();
                const cta = document.getElementById('wishlist-cta');
                cta?.classList.remove('hidden');
            });
            const button = document.querySelector('.gform-submit-button');
            const input = document.querySelector('.wishlist-ids input');
            if (button) {
                button.addEventListener('click', () => {
                    if (input) {
                        input.value = params.ids;
                    }
                });
            }
        }
    }
    static async fetch(url) {
        // Default options are marked with *
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'X-WP-Nonce': window.mainSiteData.nonce
            },
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
}
